import { VATCode } from 'Services/ProductManagement/Features/VATDefinition/types'

export const APP_NAME = 'Waltti Manager'
export const TOOLBAR_HEIGHT = 64
export const PTA_BANNER_HEIGHT = 38
export const DRAWER_WIDTH = 260
export const HEADER_CONTENT_MAX_WIDTH = '100%'
export const CONTENT_MAX_WIDTH = 1600
export const DATE_TIME_FORMAT = 'dd.MM.yyyy, HH:mm:ss'
export const BACKEND_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm'
export const DATE_FORMAT = 'yyyy-MM-dd'
export const ROWS_PER_PAGE_DEFAULT = 20
export const SINGLE_PAGE_TABLE_SKELETON_ROWS = 16
export const SINGLE_PAGE_TABLE_SKELETON_HEIGHT = 45
export const WEBSOCKET_CONNECTION_MAX_RETRIES = 10
export const TARIFF_CODE_LENGTH = 6

export const getFilterByDefaultDate = () => {
  const defaultDate = new Date()
  defaultDate.setFullYear(defaultDate.getFullYear() - 1)
  return defaultDate
}

/* Parameter constants */
export const PRODUCT_GROUP_CATEGORY = 'PRODUCT_GROUP'
export const CUSTOMER_GROUP_CATEGORY = 'CUSTOMER_GROUP'
export const SALES_CHANNEL_CATEGORY = 'SALES_CHANNEL'
export const ALLOWED_TOKENS_CATEGORY = 'ALLOWED_TOKEN'
export const DOMICILE_CLASS_CATEGORY = 'DOMICILE_CLASS'
/* Parameter constants EOF */

export const DEFAULT_VAT_DEFINITIONS = [
  {
    label: 'VAT_0',
    value: VATCode.VAT_0
  },
  {
    label: 'VAT_01',
    value: VATCode.VAT_01
  },
  {
    label: 'VAT_02',
    value: VATCode.VAT_02
  },
  {
    label: 'VAT_99',
    value: VATCode.VAT_99
  }
]

export const All_PRODUCTS_COUNT_PER_REQUEST = 10000
export const All_TARIFF_PRODUCTS_COUNT_PER_REQUEST = 10000
export const All_TARIFF_CATALOG_PRODUCTS_COUNT_PER_REQUEST = 10000
export const All_TARIFFS_COUNT_PER_REQUEST = 10000
export const All_VAT_DEFINITIONS_COUNT_PER_REQUEST = 10000

export const SORT_ORDER_ASC = 'ASCENDING'
export const SORT_ORDER_DESC = 'DESCENDING'

export const ENABLE_SPM_DELETE_BUTTON = import.meta.env.VITE_ENABLE_SPM_DELETE_BUTTON === 'true'
export const ENABLE_TARIFF_IMPORT = import.meta.env.VITE_ENABLE_TARIFF_IMPORT === 'true'
export const EXTENSION_TICKET_GROUP_CODE = '04'
export const ENABLE_TARIFF_EDIT_RESTRICTION =
  import.meta.env.VITE_ENABLE_TARIFF_EDIT_RESTRICTION === 'true'

export const IS_HSL_SERVICE_ENVIRONMENT = import.meta.env.VITE_SERVICE_ENVIRONMENT === 'HSL'
export const IS_WALTTI_SERVICE_ENVIRONMENT = import.meta.env.VITE_SERVICE_ENVIRONMENT === 'WALTTI'

export const QR_TICKET_GROUP_MIN_SIZE = 1
export const QR_TICKET_GROUP_MAX_SIZE = 40

export const LOGIN_PAGE_PATH = '/login'
export const SALES_MANAGEMENT_ROOT_URL = '/sales-management'
export const PRODUCT_MANAGEMENT_ROOT_URL = '/product-management'
export const SERVICE_PROVIDER_MANAGEMENT_ROOT_URL = '/service-provider-management'
export const CONTROL_DATA_MANAGEMENT_ROOT_URL = '/control-data-management'

export const PTA_REQUEST_HEADER_KEY = 'X-PTA'
export const SELECTED_PTA_STORAGE_KEY = 'selectedPta'

export const GLOBAL_SECTION_PATHS = [
  `${PRODUCT_MANAGEMENT_ROOT_URL}/products`,
  `${PRODUCT_MANAGEMENT_ROOT_URL}/settings/vat-definitions`,
  `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/codespaces`,
  `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/zones`
]

export const SEVERITY_LEVELS = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
  LEARN: 'learn'
} as const

export enum RTKCacheTags {
  LIST = 'LIST',
  LIST_ALL = 'LIST-ALL'
}

export const REPORT_DOWNLOAD_URL_ALLOWED_HOST_NAMES = ['storage.googleapis.com']

export const TAB_PARAM_KEY = 'tab'
export const DRAWER_TAB_PARAM_KEY = 'drawerTab'
